import {AnimatedText, Button} from '#component/base';
import {EventType, useAnalytics, UserActionEvent} from '#component/provider/AnalyticsProvider';
import {Transition} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../StorySteps.types';

import * as css from './Step0.css';

export const Step0 = ({afterEnter, firstName, onNext, show}: StepProps) => {
  const {track} = useAnalytics();

  const handleViewResults = () => {
    track<UserActionEvent>({actionName: 'Started results story', evtName: EventType.UserAction});
    onNext?.();
  };

  return (
    <Transition appear className={css.root} show={show} afterEnter={afterEnter}>
      <div className={sprinkles({flex: 'flex', dir: 'col', gap: 16})}>
        <div className={sprinkles({flex: 'flex', dir: 'col'})}>
          <AnimatedText color="white" variant="heading1">
            {`${firstName},`}
          </AnimatedText>

          <AnimatedText color="white" variant="heading1">
            your results are ready
          </AnimatedText>
        </div>

        <AnimatedText color="white" variant="bodyLarge">
          Reveal your epigenetic age.
        </AnimatedText>
      </div>

      <Button
        className={sprinkles({w: ['full', 'full', 'maxContent']})}
        onClick={handleViewResults}
        variant="primary-dark">
        View my TallyAge™
      </Button>
    </Transition>
  );
};
